import { fabric } from 'fabric-with-gestures';

export const getSvgDimensions = src => {
  return new Promise((resolve, reject) => {
    fabric.loadSVGFromURL(
      src,
      (img, options) => {
        const obj = fabric.util.groupSVGElements(img, options);
        obj.setCoords();
        resolve({ height: options.height, width: options.width });
      },
      null,
      {
        crossOrigin: 'anonymous'
      }
    );
  });
};

export const getImageDimensions = (src, contentType) => {
  if (contentType === 'image/svg+xml') {
    return getSvgDimensions(src);
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = err => {
      reject(err);
    };
    img.src = src;
  });
};
